// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13hQ-","requiredAsterisk":"Info_requiredAsterisk__2iuS3"};